import { useMemo } from 'react';
import { useQueryParams, withDefault, NumberParam, StringParam } from 'use-query-params';
import {
    PerPageLimitParam,
    CurrentPageParam,
    PaginationQueryParams,
    getPaginationRequestParams,
} from '@components/pagination';
import { InventoryQueryParams, InventoryPageSize } from './constants';

const getInventoryFilters = () => ({
    [PaginationQueryParams.Limit]: withDefault(NumberParam, InventoryPageSize),
    [PaginationQueryParams.PageNumber]: CurrentPageParam,
    [InventoryQueryParams.Ordering]: withDefault(StringParam, undefined),
});

export const useInventoryFilters = () => {
    const filters = useMemo(() => getInventoryFilters(), []);
    const [query, setQuery] = useQueryParams(filters);

    const { page, limit, ordering } = query;

    const params = useMemo(() => {
        return {
            ...getPaginationRequestParams(page, limit),

            ordering,
        };
    }, [page, limit, ordering]);

    return { query, setQuery, params };
};
